import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { HeaderProps } from "./useHeaderProps"
import { PAYMENT_METHODS } from "src/constants/payments"

const PAYMENT_TYPES = {
    amex: PAYMENT_METHODS.amex,
    consumo_interno: PAYMENT_METHODS.consumoInterno,
    cortesia: PAYMENT_METHODS.cortesia,
    deposito_o_transferencia: PAYMENT_METHODS.depositoOTransferencia,
    efectivo: PAYMENT_METHODS.efectivo,
    visa_o_mastercard: PAYMENT_METHODS.visaOMasterCard,
    love_points: PAYMENT_METHODS.lovePoints,
    mixto: { value: "mixto", label: "Mixto" },
}

type Keys = keyof typeof PAYMENT_TYPES

const getPaymentItems = (keys: Keys[]) => {
    return keys
        .map((key) => {
            const item = PAYMENT_TYPES[key]
            return { value: item?.value, valueToDisplay: item?.label }
        })
        .filter((item) => item.value !== null && item.value !== undefined && item.value !== "" && item.valueToDisplay !== null && item.valueToDisplay !== undefined && item.valueToDisplay !== "")
}

const useMetodoPagoHeader = <T extends string>({ headerValue, valueToDisplay }: HeaderProps<T>): FlexibleTableHeaderColumn => {

    const options = [
        ...getPaymentItems([
            "visa_o_mastercard",
            "amex",
            "efectivo",
            "cortesia",
            "deposito_o_transferencia",
            "consumo_interno",
            "mixto",
        ]),
    ]

    return {
        value: headerValue,
        valueToDisplay,
        filterMenu: options,
        isFilterUnique: false,
        filterSuggetions: false,
    }
}

export default useMetodoPagoHeader
